
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/au2pilot",
      function () {
        return require("private-next-pages/archive/au2pilot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/au2pilot"])
      });
    }
  